import { createSlice } from "@reduxjs/toolkit";

export const travellerSlice = createSlice({
    name: "user",
    initialState: {
      users: [], // Initialize users as an empty array
      edit_user_id: null,
      editingUser: null,
      loading: false,
      error: null,
    },
    reducers: {
        setLoading: (state) => {
          state.loading = true;
          state.error = null; 
        },
        setUsers: (state, action) => {
          state.loading = false;
          state.error = null;
          state.users = action.payload.data; 
      },
        setError: (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
        addUser: (state, action) => {
          state.users.push(action.payload);
        },
        setEditingUserId: (state, action) => {
          state.edit_user_id = action.payload;
        },
        setEditingUser: (state, action) => {
          const userId = action.payload;
          const userToEdit = state.users.find((user) => user.id === userId);
          if (userToEdit) {
            state.editingUser = userToEdit;
          }
        },
        updateUser: (state, action) => {
          const index = state.users.findIndex(
            (user) => user.id === action.payload.id
          );
          if (index !== -1) {
            state.users[index] = action.payload;
          }
          state.edit_user_id = null;
        },
        deleteUser: (state, action) => {
          state.users = state.users.filter(
            (user) => user.id !== action.payload
          );
        },
      },
})

export const {
    setLoading,
    setUsers,
    addUser,
    setEditingUserId,
    updateUser,
    deleteUser,
    setError,
    setEditingUser
  } = travellerSlice.actions;
  
  export default travellerSlice.reducer;

